import Footer from "./Footer";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {motion } from "motion/react"
import { ArrowRight } from "lucide-react";

export default function Waitlist(){
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

   const navigate = useNavigate();

   useEffect(() => {
     const  registedEmail = localStorage.getItem("waitlistEmail");
      if (registedEmail) {
    navigate('/thank-you', email);
  }
   }, [])

const handleSubmit = async () => {
  if (!email) {
    setError("Email is required");
    return;
  }

  if (!validateEmail(email)) {
    setError("Invalid email format");
    return;
  }

  setError("");

  try {
    const res = await fetch("https://storii-production.up.railway.app/register/email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email })
    });

    const data = await res.json();


  if (!res.ok) {
  if (data.message === "You already joined the waitlist") {
    localStorage.setItem("waitlistEmail", email);
    navigate('/thank-you');
    return;
  }

  setError(data.message || "Something went wrong");
  return;
   }
    localStorage.setItem("waitlistEmail", email);
    
    navigate('/thank-you');

  } catch (err) {
    setError("Server error. Try again.");
  }
};

const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!regex.test(email)) return false;

  if (email.length < 6) return false;

  if (/^\d+$/.test(email)) return false; 

  if (email.includes("test")) return false;

  return true;
};


    return(
     <div className="bg-white">
        <div className="flex flex-col items-center justify-center min-h-screen space-y-2">
        <div className="text-center">
              <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1 className="text-7xl sm:text-8xl lg:text-9xl font-black mb-1 bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 bg-clip-text text-transparent leading-tight drop-shadow-sm">
            Storii
          </h1>
        </motion.div>
               <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-4 leading-snug"
                  >
                    Waitlist
                  </motion.p>
        </div>
        <div className="grid grid-cols-1 w-[250px] text-center">
          <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="text-2xl sm:text-2xl lg:text-xl text-slate-900 mb-2 leading-snug"
                  >
                    Leave your email and we`ll norify you
                  </motion.p>
   <motion.input
  type="email"
  className={`border rounded-xl h-12 mb-2 px-4 
    ${error ? "border-red-500" : "border-gray-300"}`}
  placeholder="Enter your email"
  value={email}
  onChange={(e) => {
    setEmail(e.target.value);
    setError("");
    
  }}
  onBlur={() => {
  if (!validateEmail(email)) {
    setError("Invalid email");
  }
}}
/>
       </div>
       <div className="space-x-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <button
  onClick={handleSubmit}
  disabled={!validateEmail(email)}
  className={`group relative px-10 py-5 rounded-2xl font-bold text-lg transition-all duration-300 flex items-center gap-3
  ${validateEmail(email)
    ? "bg-black text-white hover:scale-105"
    : "bg-gray-300 text-gray-500 cursor-not-allowed"}
`}
>
  Continue →
</button>
          {/**  
          <button className="px-10 py-5 bg-white text-slate-900 rounded-2xl font-bold text-lg border-2 border-slate-300 hover:border-green-500 hover:shadow-xl transition-all duration-300 hover:scale-105">
            Continue with Google
          </button>
          */}
        </motion.div>
      </div>
      </div>
      <Footer/>
     </div>
     
    );
}